import React from "react";

interface IntentErrorBoundaryProps {
  children: React.ReactNode;
}

interface IntentErrorBoundaryState {
  hasError: boolean;
}

class IntentErrorBoundary extends React.Component<
  IntentErrorBoundaryProps,
  IntentErrorBoundaryState
> {
  state: IntentErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError(): IntentErrorBoundaryState {
    return { hasError: true };
  }

  render(): React.ReactNode {
    if (this.state.hasError) return null;
    return this.props.children;
  }
}

export default IntentErrorBoundary;
